import React from "react";
import OnboardingStep from "./OnboardingStep";

const Step2CheckIn: React.FC = () => {
  return (
    <OnboardingStep
      className="step2-check-in"
      title="Step 2: Check-In"
      description="Check-in at a bar to let others know you're playing."
    ></OnboardingStep>
  );
};

export default Step2CheckIn;
